<div
    class="radio-group-chips"
    [ngClass]="{
        'flex-wrap': chipsPerRow === 'wrap' || chipsPerRow,
        'chip-style-fill': chipStyle === 'fill',
        'chip-style-outline': chipStyle === 'outline'
    }"
    [style.--chip-width]="chipsPerRow ? 'calc(100% / ' + chipsPerRow + ' - 1rem )' : undefined"
    [style.--chip-flex-grow]="chipsPerRow && chipsPerRow !== 'wrap' ? '0' : '1'">
    @for (option of options; track option.value) {
        <ion-checkbox
            (ionChange)="onCheckboxChange($event)"
            class="radio-chip"
            [value]="option.value"
            [checked]="option.checked"
            [ngClass]="{ 'radio-checked': option.checked }">
            {{ option.label }}
        </ion-checkbox>
    }
    <ng-content></ng-content>
</div>
